
















































































































import { get, sync } from 'vuex-pathify';

const reload = () => window.location.reload();

// TODO: LF - 2020-03-14 - Need to have appropriate step name defined
// const enum STEP {
//   REQUEST_EMAIL = 1,
//   LOGIN = 2,
//   COMPLETE = 3
// }

import auth from '@/mixins/auth';
import mixins from '@/utils/mixins';

export default mixins(auth).extend({
  name: 'PasswordResetConfirm',

  data: () => ({
    showPassword1: false,
    showPassword2: false,
    password1: '',
    password2: '',
    step: 1
  }),

  computed: {
    loading: get('auth/getLoading'),
    // getAuthError: get('auth/getAuthError'),
    companyName: sync('app/companyName'),
    darkCompanyImage: sync('app/darkCompanyImage'),

    uid() {
      return this.$route.params.uid;
    },
    token() {
      return this.$route.params.token;
    }
  },

  methods: {
    reload: () => reload(),

    passwordReset() {
      this.passwordResetConfirm({
        password1: this.password1,
        password2: this.password2,
        uid: this.uid,
        token: this.token
      }).then(() => {
        this.step++;
      });
    }
  },

  async created() {
    console.log(this.uid, this.token);
  }
});
